import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzI18nService, en_US, zh_CN, ja_JP } from "ng-zorro-antd/i18n";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import * as moment from "moment";

@Component({
  selector: "change-language",
  templateUrl: "./change-language.component.html",
  styleUrls: ["./change-language.component.scss"],
})
export class ChangeLanguageComponent implements OnInit {
  visible = false;
  displayText = "日本語";
  flags = "http://www.geonames.org/flags/l/jp.gif";

  langPreference = [
    {
      flag: "http://www.geonames.org/flags/l/cn.gif",
      locale: zh_CN,
      lang: "zh",
      displayText: "中文",
      momentLanguage: "zh-cn",
    },
    {
      flag: "http://www.geonames.org/flags/l/us.gif",
      locale: en_US,
      lang: "en",
      displayText: "English",
      momentLanguage: "en-nz",
    },
    {
      flag: "http://www.geonames.org/flags/l/jp.gif",
      locale: ja_JP,
      lang: "jp",
      displayText: "日本語",
      momentLanguage: "ja",
    },
  ];

  changeLanguage(item) {
    this.translate.use(item.lang);
    this.i18n.setLocale(item.locale);
    this.flags = item.flag;
    this.displayText = item.displayText;
    localStorage.setItem("langs", JSON.stringify(item));
    moment.locale(item.momentLanguage);
    // location.reload();
  }

  constructor(
    private translate: TranslateService,
    private i18n: NzI18nService
  ) {}

  ngOnInit(): void {
    const langs = JSON.parse(localStorage.getItem("langs"));
    if (langs && langs.flag) {
      this.flags = langs.flag;
    }
  }
}
